import { pinyin_dict_notone } from './pinyin';

const dict: any = {};
Object.keys(pinyin_dict_notone).forEach((k) => {
  const temp = pinyin_dict_notone[k];
  for (let j = 0; j < temp.length; j++) {
    dict[temp[j]] = k;
  }
});

export const getPinyin = (value?: string) => {
  if (!value) {
    return '';
  }
  const result = [];
  for (let i = 0; i < value.length; i++) {
    const temp = value.charAt(i);
    if (dict[temp]) {
      result.push(dict[temp]);
    } else {
      result.push(temp);
    }
  }
  return result.join('');
};

export const getFirstPinyin = (value?: string) => {
  if (!value) {
    return '';
  }
  const result = [];
  for (let i = 0; i < value.length; i++) {
    const temp = value.charAt(i);
    if (dict[temp]) {
      result.push(dict[temp][0]);
    } else {
      result.push(temp);
    }
  }
  return result.join('');
};


export default {
  getPinyin,
  getFirstPinyin,
};
